import { Component, OnInit } from '@angular/core';
import { Department } from '@app/models/company/department.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { ReportFilter } from '@app/modules/reporting/interfaces/report-filter.interface';
import { AuthService, NotifyService } from '@app/services';
import { Job } from '@models/company/job.model';
import { Project } from '@models/time-tracking/project.model';
import { TimeTrackingDateFormatDashes } from '@time-tracking/meta/time-tracking.meta';
import moment, { Moment } from 'moment';

@Component({
    selector: 'app-time-tracking-payroll-report-filter-form',
    templateUrl: './time-tracking-payroll-report-filter.template.html',
})
export class TimeTrackingPayrollReportFilterForm extends BaseForm implements OnInit {
    startDate: Moment = moment().startOf('year');
    endDate: Moment = moment().endOf('year');
    departments: Department[] = [];
    jobs: Job[] = [];
    projects: Project[] = [];

    selectedDepartmentIds: number[] = [];
    selectedJobIds: number[] = [];
    selectedProjectIds: number[] = [];

    constructor(
        private auth: AuthService,
        private notify: NotifyService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.loadDepartments();
        this.loadJobs();
        this.loadProjects();
    }

    get filters(): ReportFilter[] {
        return [
            {
                name: 'startAt',
                value: this.startDate.format(TimeTrackingDateFormatDashes),
            },
            {
                name: 'endAt',
                value: this.endDate.format(TimeTrackingDateFormatDashes),
            },
            {
                name: 'position_ids',
                value: this.selectedJobIds,
            },
            {
                name: 'department_ids',
                value: this.selectedDepartmentIds,
            },
            {
                name: 'project_ids',
                value: this.selectedProjectIds,
            },
        ];
    }

    loadDepartments(): void {
        Department.param('company', this.auth.company.id)
            .orderBy('name', 'ASC')
            .all()
            .then(([departments]) => (this.departments = departments))
            .catch((err) => this.notify.error(err));
    }

    loadJobs(): void {
        Job.param('company', this.auth.company.id)
            .all()
            .then(([jobs]) => (this.jobs = jobs))
            .catch((err) => this.notify.error(err));
    }

    loadProjects(): void {
        Project.all()
            .then(([projects]) => (this.projects = [new Project({ name: 'No Project', id: null }), ...projects]))
            .catch((err) => this.notify.error(err));
    }
}
